import { lazyLoad } from 'app/utils/loadable';

export const Auth = lazyLoad(
  () => import('./auth'),
  (module) => module.Auth
);
